var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M3.278 7.628L5.36 2.072H20.64l2.083 5.556zm17.36 6.944c-1.18 0-2.082-.902-2.082-2.083 0-1.18.903-2.083 2.083-2.083 1.18 0 2.083.903 2.083 2.083 0 1.18-.903 2.083-2.083 2.083zm-15.277 0c-1.18 0-2.083-.902-2.083-2.083 0-1.18.903-2.083 2.083-2.083 1.18 0 2.083.903 2.083 2.083 0 1.18-.903 2.083-2.083 2.083zM22.584 1.378a2.023 2.023 0 0 0-1.945-1.389H5.36c-.903 0-1.667.556-1.945 1.389L.5 9.017v10.417c0 .763.625 1.388 1.389 1.388h1.389c.763 0 1.389-.625 1.389-1.388v-.695h16.666v.695c0 .763.626 1.388 1.39 1.388h1.388c.764 0 1.389-.625 1.389-1.388V9.017z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.2774991f77e35ae4545dce643ab28e97.svg";
export { ForwardRef as ReactComponent };